window.addEventListener('load', function() {
  const selectors = {
    deluxeSamples: '.deluxe-samples__samples',
    deluxeSample: '.deluxe-sample',
    deluxeSampleInput: '[data-deluxe-sample-input]',
    deluxeSampleOne: '[data-sample-one]',
    deluxeSampleTwo: '[data-sample-two]'
  }

  $(selectors.deluxeSampleInput).on('change', function(evt) {
    if($(`${selectors.deluxeSampleInput}:checked`).length > 2) {
      if($(this).data('deluxe-sample-input') != "no-thanks") {
        evt.preventDefault();
        this.checked = false;
      }
    } else {
      $('[data-deluxe-sample-input="no-thanks"]')[0].checked = false;
      let sampleOne = $($(`${selectors.deluxeSampleInput}:checked`)[0]).val();
      let sampleTwo = $($(`${selectors.deluxeSampleInput}:checked`)[1]).val();
      $(selectors.deluxeSampleOne).val(sampleOne);
      $(selectors.deluxeSampleTwo).val(sampleTwo);
      fetch("/cart/update.js", {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          attributes: {
            "Sample one:": sampleOne,
            "Sample two:": sampleTwo
          }
        })
      })
      .then(response => response.json())
      .then(data => console.log('cart updated: ', data));
    }
    if($(this).data('deluxe-sample-input') == "no-thanks") {
      // remove all
      $(`${selectors.deluxeSampleInput}:checked`).each(function(index, box) {
        box.checked = false;
      })
      this.checked = true;
      $(selectors.deluxeSampleOne).val("");
      $(selectors.deluxeSampleTwo).val("");
      fetch("/cart/update.js", {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          attributes: {
            "Sample one:": "",
            "Sample two:": ""
          }
        })
      })
      .then(response => response.json())
      .then(data => console.log('cart updated: ', data));
    }
  })
})
